<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from "@/utils/uiWrapper";
import FooterViewOld from "./Old/OldIndependentAcceleratorsView.vue";
import NewFooterView from "./New/NewIndependentAcceleratorsView.vue";

const current = useUiWrapper(FooterViewOld, NewFooterView);
</script>
